import { connect } from 'react-redux';
import Incoming from './Incoming';
import {
  getIncoming,
  getIncomingListAreas,
  getIncomingListBoxes,
  getIncomingListStocks,
  getIncomingReject,
  getIncomingErrorFalse,
  setInitialStateIncoming
} from '../../../store/actions/incoming';
import { modalErrorOpen } from '../../../store/actions/modalError';
import {
  modalPostStockConsignmentOpen,
  modalSKZipOpen
} from '../../../store/actions/modal';

const mapStateToProps = ({
  incomingReducer,
  settingsReducer,
  tabsReducer,
  userReducer
}) => ({
  incomingReducer,
  settingsReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getIncoming,
  getIncomingListAreas,
  getIncomingListBoxes,
  getIncomingListStocks,
  getIncomingReject,
  getIncomingErrorFalse,
  modalErrorOpen,
  modalPostStockConsignmentOpen,
  modalSKZipOpen,
  setInitialStateIncoming
};

const IncomingConsignment = connect(
  mapStateToProps,
  mapDispatchToProps
)(Incoming);

export default IncomingConsignment;
